module.exports = __webpack_public_path__ + "static/img/gift-5.a34f569.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-5.png
// module id = 365
// module chunks = 140